import './message.scss';
import { IMessageData } from '../../models/message.props';
import { NOTIFICATIONS_TYPES } from '../../../../../../helpers/constants';
import infoIcon from '../../../../../../assets/icons/info.png';
import warningIcon from '../../../../../../assets/icons/warning.png';
import successIcon from '../../../../../../assets/icons/success.png';
import errorIcon from '../../../../../../assets/icons/error.png';

const getIconForType = (type: string) => {
    switch (type) {
        case NOTIFICATIONS_TYPES.success:
            return successIcon;
        case NOTIFICATIONS_TYPES.info:
            return infoIcon;
        case NOTIFICATIONS_TYPES.warning:
            return warningIcon;
        case NOTIFICATIONS_TYPES.error:
            return errorIcon;
        default:
            return infoIcon;
    }
}

const Message = ({ type = 'success', message, showIcon = true, visible = true }: IMessageData) => {
    return (
        visible ? 
        (
            <div className={`glu-message-container-body glu-message-container--state-${type}`}>
                {showIcon ? <img src={getIconForType(type)} alt='info' className="glu-message-container-body__icon" /> : null}
                <div className='glu-message-container-body__content'>
                    {message}
                </div>
            </div>
        ) : 
        null
    );
};

export default Message;
